const emailUs = (function ($) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        queryList: [],

        ajax: {
            get: 'GET',
            contentType: 'application/json',
            dataType: 'json'
        },
        urls: {
            error: '/error/error-page',
            sendEmail: '/api/sitecore/EmailUs/SendEmail'
        },
        gtm: {
            submitButtonClickEventState: function (status) {
                const href = document.location.href.split('/');
                return {
                    event: 'ga_event',
                    category: 'form submission',
                    action: status,
                    label: href[href.length - 1] + ' form',
                    value: 0,
                    nonInteraction: 0
                };
            }
        },
        elements: {
            select: {
                questionTypeList: 'select#question-type-list',
                topicList: 'select#topic-list',
                queryList: 'select#query-text'
            },
            textbox: {
                message: '#member-message',
                phoneNumber: '#member-telephone',
                firstName: '#member-first-name',
                surName: '#member-surname',
                title: '#member-title',
                emailAddress: '#member-email-address'
            },
            label: {
                contactLabel: '#contact-label',
                contactErrorLabel: '#contact-error-label',
                questionLabel: '#member-question-label',
                topicLabel: '#topic-label',
                queryLabel: '#query-label',
                topicErrorLabel: '#member-topic-error-label',
                queryErrorLabel: '#member-query-error-label',
                questionErrorLabel: '#member-question-error-label',
                messageLabel: '#member-text-message',
                messageErrorLabel: '#member-message-error-label'
            },
            notification: {
                success: '.vds-notification--success',
                failure: '.vds-notification--alert'
            },
            button: {
                send: '#send-email',
                sendLoading: '#send-email-loading'
            }
        },
        func: {
            init: function (inputData) {
                $(self.elements.notification.success).hide();
                $(self.elements.notification.failure).hide();
                $(self.elements.button.send).show();
                $(self.elements.button.sendLoading).hide();
                self.func.clearSelectOptions(self.elements.select.topicList);
                self.func.clearSelectOptions(self.elements.select.queryList);
                $(self.elements.label.topicLabel).hide();
                $(self.elements.label.queryLabel).hide();
                self.queryList = inputData;
                self.func.bindEvents();
            },
            bindEvents: function () {
                $('#send-email').on('click', function (e) {
                    $(self.elements.notification.success).hide();
                    $(self.elements.notification.failure).hide();
                    if (self.func.validatePartner()) {
                        $(self.elements.button.send).hide();
                        $(self.elements.button.sendLoading).show();
                        const data = JSON.stringify({
                            QueryCategoryCode: self.func.getSelectOptions(self.elements.select.questionTypeList),
                            FirstName: $(self.elements.textbox.firstName).val(),
                            Surname: $(self.elements.textbox.surName).val(),
                            PartnerTopic: self.func.getSelectOptions(self.elements.select.questionTypeList) != "VITCAR" ? self.func.getTopic() : "",
                            PartnerQuery: self.func.getSelectOptions(self.elements.select.questionTypeList) != "VITCAR" ? self.func.getQuery() : "",
                            CarTopic: self.func.getSelectOptions(self.elements.select.questionTypeList) == "VITCAR" ? self.func.getTopic() : "",
                            CarQuery: self.func.getSelectOptions(self.elements.select.questionTypeList) == "VITCAR" ? self.func.getQuery() : "",
                            Complaint: 'No',
                            Comment: $(self.elements.textbox.message).val(),
                            Title: $(self.elements.textbox.title).val(),
                            QueryCategory: self.func.getSelectOptionsText(self.elements.select.questionTypeList),
                            ContactDetails: {
                                EmailAddress: $(self.elements.textbox.emailAddress).val(),
                                ContactNumber: $(self.elements.textbox.phoneNumber).val()
                            }
                        });

                        self.func.sendEmail(data);
                    }
                    e.preventDefault();
                });

                $(self.elements.select.questionTypeList).change(function () {
                    $(self.elements.notification.success).hide();
                    $(self.elements.notification.failure).hide();
                    self.func.clearSelectOptions(self.elements.select.topicList);
                    self.func.clearSelectOptions(self.elements.select.queryList);
                    $(self.elements.label.topicLabel).hide();
                    $(self.elements.label.queryLabel).hide();
                    self.func.updateSelectList(
                        self.elements.select.questionTypeList,
                        self.elements.select.topicList,
                        self.elements.label.topicLabel);

                    $(self.elements.label.topicErrorLabel).hide();
                    $(self.elements.label.queryErrorLabel).hide();
                });

                $(self.elements.select.topicList).change(function () {
                    $(self.elements.notification.success).hide();
                    $(self.elements.notification.failure).hide();
                    self.func.clearSelectOptions(self.elements.select.queryList);
                    $(self.elements.label.queryLabel).hide();

                    self.func.updateSelectList(
                        self.elements.select.topicList,
                        self.elements.select.queryList,
                        self.elements.label.queryLabel);
                });
            },
            filterQueryList: function (select) {
                const filterBy = self.func.getSelectOptions(select);

                if (filterBy.length > 0) {
                    return self.queryList.filter(function (obj) {
                        return (obj.ParentCode === filterBy);
                    });
                } else {
                    return [];
                }
            },
            loadSelectOption: function (fiteredData, target) {
                for (let i = 0; i < fiteredData.length; i++) {
                    $(target).append('<option value=\"' + fiteredData[i].Code
                        + '\">' + fiteredData[i].Description.replace('--', "'") + '</option>');
                }
            },
            updateSelectList: function (source, target, targetLabel) {
                const fiteredData = self.func.filterQueryList(source);

                if (fiteredData.length > 0) {
                    self.func.loadSelectOption(fiteredData, target);

                    $(target).show();
                    $(targetLabel).show();
                }
            },
            clearSelectOptions: function (select) {
                $(select).empty();
                $(select).hide();
            },
            getTopic: function () {
                let topic = self.func.getSelectOptions(self.elements.select.topicList);
                if (topic === undefined) {
                    topic = '';
                }

                return topic;
            },
            getQuery: function () {
                let query = self.func.getSelectOptions(self.elements.select.queryList);
                if (query === undefined) {
                    query = '';
                }

                return query;
            },
            getSelectOptions: function (select) {
                return $(select).children('option:selected').val();
            },
            getSelectOptionsText: function (select) {
                return $(select).children('option:selected').text();
            },
            sendEmail: function (inputData) {
                $.ajax({
                    type: self.ajax.get,
                    url: self.urls.sendEmail,
                    contentType: self.ajax.contentType,
                    data: {emailContent: inputData},
                    dataType: self.ajax.dataType,
                    success: function (response) {
                        if (response.referenceId) {
                            $(self.elements.button.send).show();
                            $(self.elements.button.sendLoading).hide();
                            $(self.elements.notification.success).show();
                            $(self.elements.textbox.message).val('');
                            $(self.elements.select.questionTypeList).val('');
                            $(self.elements.select.topicList).val('');
                            $(self.elements.select.queryList).val('');
                            window.dataLayer.push(self.gtm.submitButtonClickEventState('success'));
                        } else {
                            self.func.serviceFailure();
                        }
                    },
                    error: function () {
                        self.func.serviceFailure();
                    }
                });
            },
            serviceFailure: function () {
                window.dataLayer.push(self.gtm.submitButtonClickEventState('failure'));
                $(self.elements.button.send).show();
                $(self.elements.button.sendLoading).hide();
                $(self.elements.notification.failure).show();
            },
            isValidMessage: function () {
                if ($(self.elements.textbox.message).val() === '') {
                    $(self.elements.label.messageLabel).hide();
                    $(self.elements.label.messageErrorLabel).show();
                    return false;
                }

                $(self.elements.label.messageErrorLabel).hide();
                $(self.elements.label.messageLabel).show();
                return true;
            },
            phoneNumberValidation: function () {
                const phonenumber_regex = /^[0-9]*[1-9][0-9]*$/;
                const phonenumber = $(self.elements.textbox.phoneNumber).val().match(phonenumber_regex);

                if (phonenumber === null) {
                    $(self.elements.label.contactLabel).hide();
                    $(self.elements.label.contactErrorLabel).show();

                    return false;
                } else {
                    $(self.elements.label.contactLabel).show();
                    $(self.elements.label.contactErrorLabel).hide();

                    return true;
                }
            },
            isValidPhoneNumber: function () {
                const phoneNumberLength = $(self.elements.textbox.phoneNumber).val().length;
                if (phoneNumberLength > 0) {

                    if (phoneNumberLength < 10) {
                        $(self.elements.label.contactLabel).hide();
                        $(self.elements.label.contactErrorLabel).show();

                        return false;
                    }

                    return self.func.phoneNumberValidation();
                } else {
                    $(self.elements.label.contactLabel).show();
                    $(self.elements.label.contactErrorLabel).hide();
                }

                return true;
            },
            isValidSelectOptions: function (select, selectLabel, errorLabel) {
                if ($(select).is(':visible')) {
                    if ($(select).val() === '') {
                        $(selectLabel).hide();
                        $(errorLabel).show();

                        return false;
                    }

                    $(selectLabel).show();
                    $(errorLabel).hide();
                }
                return true;
            },
            isValidSelect: function () {
                let isValid = true;

                if (!self.func.isValidSelectOptions(
                    self.elements.select.questionTypeList,
                    self.elements.label.questionLabel,
                    self.elements.label.questionErrorLabel
                )) {
                    isValid = false;
                }

                if (!self.func.isValidSelectOptions(
                    self.elements.select.topicList,
                    self.elements.label.topicLabel,
                    self.elements.label.topicErrorLabel
                )) {
                    isValid = false;
                }

                if (!self.func.isValidSelectOptions(
                    self.elements.select.queryList,
                    self.elements.label.queryLabel,
                    self.elements.label.queryErrorLabel
                )) {
                    isValid = false;
                }

                return isValid;
            },
            validatePartner: function () {
                let isValid = true;

                if (!self.func.isValidSelect()) {
                    isValid = false;
                }

                if (!self.func.isValidMessage()) {
                    isValid = false;
                }

                if (!self.func.isValidPhoneNumber()) {
                    isValid = false;
                }

                return isValid;
            }
        },
    };

    return {
        Init: self.func.init
    };
})(jQuery
);



